/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuShapeCircle4Icon20Solid = forwardRef('UiMenuShapeCircle4Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18 5.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M5.5 18a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M14.5 18a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M5.5 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" })));
});
